<span class="toggle-filter" (click)="toggle()">

  @if (!toggleOpen) {
    <mat-icon>keyboard_arrow_down</mat-icon>
  }
  @if (toggleOpen) {
    <mat-icon>keyboard_arrow_up</mat-icon>
  }
</span>
